<template>
  <div class="tn-stay">
    <div class="tn-stay__end">
      <span class="tn-stay__label">{{ startLabel }}</span>
      <span class="tn-stay__date">{{ date(start) }}</span>
      <span class="tn-stay__day">{{ weekday(start) }}</span>
    </div>
    <div class="tn-stay__nights">
      <span class="tn-stay__line"></span>
      <span class="tn-stay__badge">{{ middle || '—' }}</span>
      <span class="tn-stay__line"></span>
    </div>
    <div class="tn-stay__end tn-stay__end--right">
      <span class="tn-stay__label">{{ endLabel }}</span>
      <span class="tn-stay__date">{{ date(end) }}</span>
      <span class="tn-stay__day">{{ weekday(end) }}</span>
    </div>
  </div>
</template>

<script>
import { formatDate, formatWeekday } from '../../utils/format'

export default {
  name: 'StayStrip',
  props: {
    start: { type: String, default: null },
    end: { type: String, default: null },
    startLabel: { type: String, default: 'Check-in' },
    endLabel: { type: String, default: 'Check-out' },
    middle: { type: String, default: '' }
  },
  methods: {
    date (value) {
      return formatDate(value)
    },
    weekday (value) {
      return formatWeekday(value)
    }
  }
}
</script>
